import React, { useMemo } from 'react'
import { Box, LinearProgress, Paper, Typography } from '@mui/material'
import { useUiTestRun } from '@/modules/ui-test/UiTestRunContext'
import { useI18n } from '@/contexts/I18nContext'
import { banhangKiotLike } from '@/components/layout/banhangKiotTokens'
import { getUiTestRunAllProgress } from '@/modules/ui-test/uiTestSession'

export const UiTestRunBanner: React.FC = () => {
  const { t } = useI18n()
  const r = (k: string) => t(`components.menu.uiTestPage.${k}`)
  const { progress } = useUiTestRun()
  const runAll = useMemo(() => getUiTestRunAllProgress(), [progress?.done, progress?.message])

  const done = progress?.done ?? 0
  const total = progress?.total ?? 1
  const pct = total > 0 ? Math.min(100, Math.round((done / total) * 100)) : 0

  return (
    <Paper
      data-ui-test-overlay="true"
      elevation={4}
      sx={{
        position: 'fixed',
        right: 16,
        bottom: 16,
        zIndex: 1400,
        px: 2,
        py: 1,
        minWidth: 320,
        maxWidth: 'min(520px, calc(100vw - 24px))',
        border: '1px solid rgba(21, 101, 192, 0.35)',
        bgcolor: 'rgba(255,255,255,0.97)',
      }}
    >
      <Typography
        sx={{
          mb: 0.75,
          fontFamily: banhangKiotLike.kiotFontStack,
          fontSize: 12,
          fontWeight: 600,
          color: '#1565c0',
        }}
      >
        {runAll
          ? r('runningLiveBannerAll')
              .replace('{current}', String(runAll.current))
              .replace('{total}', String(runAll.total))
          : r('runningLiveBanner')}
      </Typography>
      <Typography
        sx={{
          mb: 0.75,
          fontFamily: banhangKiotLike.kiotFontStack,
          fontSize: 11,
          color: banhangKiotLike.kiotTextSecondary,
        }}
      >
        {progress?.message ?? r('runningOnPage')}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <LinearProgress variant="determinate" value={pct} sx={{ flex: 1, height: 6, borderRadius: 1 }} />
        <Typography sx={{ fontFamily: banhangKiotLike.kiotFontStack, fontSize: 11, minWidth: 36 }}>
          {done}/{total}
        </Typography>
      </Box>
    </Paper>
  )
}
